import { SolicitationContext, } from "@/contexts/SolicitationContext";
import { useContext } from "react";
export function useSolicitation() {
    var context = useContext(SolicitationContext);
    if (!context) {
        throw new Error("useSolicitation must be used within a SolicitationProvider");
    }
    return context;
}
